import { createTheme } from '@mui/material';
import { createPalette } from './palette';
import { ruRU } from '@mui/material/locale';
import { ruRU as coreRuRU } from '@mui/material/locale';

const palette = createPalette();

export const theme = createTheme({ palette: palette }, ruRU, coreRuRU);
